import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import { helper } from './utils/helper'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

import { abilitiesPlugin } from '@casl/vue'
import ability from '@u/ability'

import fontawesomeComponent from './components/baseComponents/fontawesome'
import ADDFComponents from './components/addf-package/components'
import globalComponents from './components/baseComponents/theme-global-components'

import utils from './utils'
import './libs'
import './assets/tailwind.css'

// The authenticated user is set on Bugsnag at login and by auth/refreshAuth.
Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_KEY,
  plugins: [new BugsnagPluginVue()],
  enabledReleaseStages: ['production', 'staging', 'vdb'],
  enabledBreadcrumbTypes: ['error', 'navigation', 'request', 'user'],
  appVersion: import.meta.env.VITE_APP_VERSION,
  releaseStage: import.meta.env.MODE,
  // API errors are toasted (and the 5xx reported) by apiClient: a store
  // action rejecting with one is not a new error.
  onError: (event) =>
    !(event.unhandled && event.originalError?.handledByApiClient)
})

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.handledByApiClient) event.preventDefault()
})

const bugsnagVue = Bugsnag.getPlugin('vue')

const app = createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(bugsnagVue)
  .use(abilitiesPlugin, ability, {
    useGlobalProperties: true
  })

ADDFComponents(app)
fontawesomeComponent(app)
globalComponents(app)
utils(app)

app.config.errorHandler = (err, instance, info) => {
  if (err?.handledByApiClient) return
  if (import.meta.env.PROD) {
    Bugsnag.notify(err)
  } else {
    helper.toastInfo(
      "Une erreur s'est produite. L'équipe support a été notifiée de cette erreur.",
      null,
      'toastErrorHandler'
    )
  }
  console.log(err)
  console.log(instance)
  console.log(info)
}

app.mount('#app')
